function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1798 3.57759C24.098 7.2785 22.7531 13.5009 20.7003 15.1763C17.7238 17.6056 15.4121 16.6902 14.5123 19.4864C13.6958 22.0236 19.0555 32.6515 38.716 32.6515C58.3765 32.6515 63.7361 22.0236 62.9196 19.4864C62.0198 16.6902 59.7081 17.6056 56.7316 15.1763C53.7551 12.747 52.2668 0.757324 38.716 0.757324C36.2725 0.757324 34.2212 1.14712 32.4827 1.80054",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.1994 24.011C48.4825 25.9918 43.8967 26.9996 38.7175 26.9996C29.1142 26.9996 21.5502 23.5343 17.7852 16.8267M59.6499 16.8267C58.5302 18.8216 57.0744 20.5297 55.3288 21.9452",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.8214 7.23337L44.6886 13.121L45.8012 26.29M38.7193 0.756836V8.41902M25.6172 7.23337L32.7501 13.121L31.6374 26.29",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7995 26.29L44.6869 13.1209L38.7176 8.41895L32.7484 13.1209L31.6357 26.29M13.2691 28.1842C14.3873 28.6908 15.5543 28.9843 16.7738 28.9843C18.6561 28.9843 20.1365 28.8181 21.245 28.6153C21.2449 28.6154 15.9349 37.83 15.2249 38.0884C14.826 38.2335 13.4895 38.7865 12.6129 39.5523C11.785 40.2755 12.2981 41.6396 13.3973 41.6396H19.6729C20.3544 41.6396 21.0263 41.4787 21.6339 41.1699C22.2415 40.8611 22.7677 40.4132 23.1696 39.8626L29.1556 31.6626M15.5486 17.8851C14.2255 15.5068 12.8141 13.1352 11.9334 12.1322C8.25463 7.94348 3.002 10.6005 1.41363 11.7448C-0.0842488 12.8239 2.84313 18.0717 4.5115 20.1386C6.21813 22.253 8.07713 24.4685 10.1159 26.1533M48.7782 31.5445C49.9395 33.8984 51.4801 37.1348 51.56 37.8947C51.6062 38.3347 51.3869 38.9409 51.0864 39.5374C50.6009 40.5013 51.2869 41.6396 52.3659 41.6396H58.915C59.9352 41.6396 60.632 40.6076 60.2511 39.6608L55.8807 28.7948M6.73338 14.0939V14.9553",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTortoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTortoise);
export default __webpack_public_path__ + "static/media/tortoise.75f42d495c65c3ca733ac78f3d738772.svg";
export { ForwardRef as ReactComponent };